<script setup>
import {computed, watch} from "vue";
import {useStore} from "vuex";
import useDates from "@/composables/useDates";
import HintSquare from "@/components/global-themed/HintSquare.vue";
import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import RefreshCompetitorButton from "@/components/competition/partials/RefreshCompetitorButton.vue";

const dates = useDates();

const store = useStore();

const competitors = computed(() => store.getters['competitionV2/competitors'].filter((competitor) => !competitor.isWebsiteAsCompetitor));

const selectedCompetitor = computed(() => store.getters['competitionV2/competitor']);

watch(selectedCompetitor, () => {
  if (selectedCompetitor.value === undefined) {
    store.dispatch('competitionV2/setCompetitorDetails', undefined);
    return;
  }
  store.dispatch('competitionV2/fetchCompetitorDetails');
})

const changeCompetitor = (event) => {
  const selectedId = event.target.value;
  if (!selectedId) {
    store.dispatch('competitionV2/setCompetitor', undefined);
    return;
  }

  const newSelectedCompetitor = competitors.value.find(competitor => competitor.id.toString() === selectedId);
  store.dispatch('competitionV2/setCompetitor', newSelectedCompetitor);
}

</script>

<template>
  <div class="tw-flex tw-divide-x">
    <div class="tw-w-full tw-flex-grow-1 tw-pr-8">
      <label
        for="competitor"
        class="tw-text-grey tw-mb-4"
      >
        Select Competitor
      </label>
      <SelectInput
        id="competitor"
        @change="changeCompetitor"
      >
        <template #icon>
          <svg-vue
            icon="icons/graph-search"
            class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
          />
        </template>
        <template #default>
          <option
            v-for="competitor in competitors"
            :key="competitor.id"
            :value="competitor.id"
            :selected="selectedCompetitor?.id === competitor.id"
          >
            {{ competitor.simpleUrl }}
          </option>
        </template>
      </SelectInput>
    </div>

    <div
      v-if="selectedCompetitor"
      class="tw-pl-8 tw-flex tw-flex-col"
    >
      <span class="tw-text-grey tw-mb-auto">Last Audit</span>
      <div class="tw-flex tw-items-center tw-gap-4">
        <span class="tw-whitespace-nowrap tw-text-lg tw-text-grey-dark">
          {{ dates.formattedDate(selectedCompetitor.lastAuditedAt, 'Do MMMM YYYY') }}
        </span>

        <HintSquare hint="Date that the audit for this domain was last completed." />

        <RefreshCompetitorButton />
      </div>
    </div>
  </div>
</template>
